import ArrowButton, { ArrowButtonProps, ArrowButtonType } from "./ArrowButton";

export { ArrowButton, ArrowButtonProps, ArrowButtonType };

export default ArrowButton;
